export const examRules = [
    {
        title: 'Identity Verification Before Exam:',
        description1: 'Candidates must submit a government-issued photo ID for verification.',
        description2: 'A live facial recognition check may be conducted before starting the exam.',
    },
    {
        title: 'Secure Exam Environment:',
        description1: 'Examinees must take the test in a quiet, well-lit room with no other people.',
        description2: 'Using mobile phones, tablets, smartwatches, earpieces, or any other electronic devices is strictly prohibited.',
    },
    {
        title: 'Computer and Internet Requirements:',
        description1: 'A stable internet connection is required.',
        description2: 'The exam must be on a desktop or laptop with a functioning webcam and microphone.',
    },
    {
        title: 'Proctoring and Monitoring:',
        description1: 'The exam will be proctored live through the screen recording, webcam, and microphone.',
        description2: 'Any suspicious activity (looking away from the screen, speaking to someone, etc.) may result in disqualification.',
    },
    {
        title: 'Exam Access:',
        description1: 'Candidates will receive a unique, time-sensitive link to access the exam.',
        description2: 'Logging in from multiple devices is not permitted.',
    },
    {
        title: 'Time Management:',
        description1: 'The exam must be completed within the specified time frame.',
        description2: 'No breaks are allowed during the exam.',
    },
    {
        title: 'Technical Issues:',
        description1: 'In case of technical difficulties, candidates should immediately report to the help section.',
        description2: 'Any lost time due to technical issues will be evaluated case-by-case.',
    },
    {
        title: 'Post-Exam Verification:',
        description1: 'Re-checks of identity may be conducted after the exam.',
        description2: 'Examination results are subject to verification of compliance with these rules.',
    },
    {
        title: 'Data Privacy:',
        description1: 'Personal data collected for KYC purposes will be handled under privacy laws and regulations.',
        description2: '',
    },
    {
        title: 'Pre-Exam System Check:',
        description1: 'Candidates are required to perform a system check of their computer, webcam, and microphone before the exam.',
        description2: 'Ensure that all necessary software for the exam is installed and functioning correctly.',
    },
    {
        title: 'Browser Restrictions:',
        description1: 'The exam must be on a secure browser, restricting access to other websites, software, and functionalities.',
        description2: 'The use of virtual machines or remote desktop software is prohibited.',
    },
    {
        title: 'Communication Restrictions:',
        description1: 'Communication with others is not permitted during the exam.',
        description2: 'Any form of collaboration or assistance from another person is considered cheating.',
    },
    {
        title: 'Screen, Audio and Video Recording:',
        description1: 'The entire exam duration will be recorded screen, audio-visually for monitoring and review purposes.',
        description2: 'Candidates must agree to this condition before starting the exam.',
    },
    {
        title: 'Penalties for Non-Compliance:',
        description1: 'Violating these rules may result in immediate disqualification and potential barring from future exams.',
        description2: '',
    },
];

export const questionHelp = [
    'Don’t know the answer',
    'Wrong question',
    'Wrong answers',
    'More than one answer',
];